<!--
 * @LastEditTime: 2020-03-02 16:54:48
 * @Description: 指标趋势图
 * @Date: 2020-02-27 20:44:48
 * @Author: @虾哔哔
 -->
<template>
  <div class="trend">
    <span>指标趋势图</span>
    <el-select v-model="selectValue" style="width:120px;margin-left:20px">
      <el-option
        v-for="(item,index) in chartSelect"
        :key="index"
        :value="item.id"
        :label="item.name"
      ></el-option>
    </el-select>
    <ve-line :data="tread" :settings="chartSettings" :colors='colors' :legend-visible='false' :extend="chartExtends"></ve-line>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    this.chartSettings = {
      min: [0],
      labelMap: {
        user: "服务人数",
        session: "已完成会话",
        manual: "服务转人工",
        chat: "总咨询量",
        known: "知识命中数",
        unknown: "未知回答数"
      }
    };
    return {
      selectValue: "user",
      chartSelect: [
        {
          name: "服务人数",
          id: "user"
        },
        {
          name: "已完成会话",
          id: "session"
        },
        {
          name: "服务转人工",
          id: "manual"
        },
        {
          name: "总咨询量",
          id: "chat"
        },
        {
          name: "知识命中数",
          id: "known"
        },
        {
          name: "未知回答数",
          id: "unknown"
        }
      ],
      colors:['#4261F7'],
      tread: {
        columns: [
          "date",
          "user",
          // "session",
          // "manual",
          // "chat",
          // "known",
          // "unknown"
        ],
        rows: this.data
      },
      chartExtends:{
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          textStyle: "#333",
          extraCssText: "box-shadow:0px 2px 8px rgba(119,119,119,0.47);"
        },
        xAxis: {
          axisLine: { 
            show: false
          },
          axisTick: { 
            alignWithLabel: true,
            show: false
          },
          axisLabel: { 
            color: 'rgba(159, 157, 168, 1)',
            z: 8,
            width: '100%',
            backgroundColor: '#fff'
          }
        },
        axisPointer: {
          lineStyle: {
            color: 'rgba(65, 98, 251, 0.5)',
            type: 'dashed'
          },
          z: 2
        },
        yAxis: {
          axisLine: { 
              show: false
            },
            axisTick: { 
              alignWithLabel: true,
              show: false
            },
            axisLabel: { 
              color: 'rgba(159, 157, 168, 1)'
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(233, 232, 241, .3)'
              }
            }
        },
         series: {
          smooth:true,
          type: "line",
          symbolSize: 10,
          symbol: 'circle',
          itemStyle: {
              borderColor: 'rgba(255,255,255,1)',
              borderWidth: 6,
              shadowColor: `rgba(65, 98, 251, 0.3)`,
              shadowBlur: 20,
              color: `rgb(65,98,251)`,
              opacity: 0
            },
            emphasis: {
              itemStyle: {
                borderColor: 'rgba(255,255,255,1)',
                borderWidth: 6,
                shadowColor: `rgba(65, 98, 251, 0.3)`,
                shadowBlur: 20,
                color: `rgb(65,98,251)`,
                opacity: .8,
              }
            },
            lineStyle: {
              width: 2,
              color: `rgb(65,98,251)`
            },
            areaStyle: {
                normal: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0, color: `rgba(65,98,251,.3)`
                        }, {
                            offset: 1, color: `rgba(65,98,251,0)`
                        }],
                        global: false
                    }
                },
            }
          
        }
      }
    }
  },
  watch: {
    selectValue(val) {
      this.tread.columns = ["date"];
      this.tread.columns.push(val);
    },
    data:{
      handler:function(val){
        console.log(val.map(item=>item.user))
        this.tread.rows = val
      },
      immediate:true
    }
  },
};
</script>

<style lang="less" scoped>
@deep:~">>>";
.trend {
  margin-top: 20px;
  span{
    font-size: 16px;
    font-weight: 600;
  }
  @{deep}.el-select{
    .el-input__inner{
      border: none;
      text-align: right;
    }
  }
}
</style>
